import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisLocationFilterOptionsQueryVariables = Types.Exact<{
  input: Types.HrisLocationsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisLocationFilterOptionsQuery = { __typename?: 'Query', HrisLocations: { __typename?: 'HrisLocations', objects: Array<{ __typename?: 'HrisLocation', id: number, name: string }> } };

export type HrisTeamFilterOptionsQueryVariables = Types.Exact<{
  input: Types.HrisTeamsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisTeamFilterOptionsQuery = { __typename?: 'Query', HrisTeams: { __typename?: 'HrisTeams', objects: Array<{ __typename?: 'HrisTeam', id: number, name: string }> } };

export type HrisLocationFilterOptionFragment = { __typename?: 'HrisLocation', id: number, name: string };

export type HrisTeamFilterOptionFragment = { __typename?: 'HrisTeam', id: number, name: string };

export const HrisLocationFilterOptionFragmentDoc = gql`
    fragment HrisLocationFilterOption on HrisLocation {
  id
  name
}
    `;
export const HrisTeamFilterOptionFragmentDoc = gql`
    fragment HrisTeamFilterOption on HrisTeam {
  id
  name
}
    `;
export const HrisLocationFilterOptionsDocument = gql`
    query HrisLocationFilterOptions($input: HrisLocationsInput!, $pagination: PaginationInput) {
  HrisLocations(input: $input, pagination: $pagination) {
    objects {
      ...HrisLocationFilterOption
    }
  }
}
    ${HrisLocationFilterOptionFragmentDoc}`;

/**
 * __useHrisLocationFilterOptionsQuery__
 *
 * To run a query within a React component, call `useHrisLocationFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisLocationFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisLocationFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisLocationFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<HrisLocationFilterOptionsQuery, HrisLocationFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisLocationFilterOptionsQuery, HrisLocationFilterOptionsQueryVariables>(HrisLocationFilterOptionsDocument, options);
      }
export function useHrisLocationFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisLocationFilterOptionsQuery, HrisLocationFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisLocationFilterOptionsQuery, HrisLocationFilterOptionsQueryVariables>(HrisLocationFilterOptionsDocument, options);
        }
export type HrisLocationFilterOptionsQueryHookResult = ReturnType<typeof useHrisLocationFilterOptionsQuery>;
export type HrisLocationFilterOptionsLazyQueryHookResult = ReturnType<typeof useHrisLocationFilterOptionsLazyQuery>;
export type HrisLocationFilterOptionsQueryResult = Apollo.QueryResult<HrisLocationFilterOptionsQuery, HrisLocationFilterOptionsQueryVariables>;
export const HrisTeamFilterOptionsDocument = gql`
    query HrisTeamFilterOptions($input: HrisTeamsInput!, $pagination: PaginationInput) {
  HrisTeams(input: $input, pagination: $pagination) {
    objects {
      ...HrisTeamFilterOption
    }
  }
}
    ${HrisTeamFilterOptionFragmentDoc}`;

/**
 * __useHrisTeamFilterOptionsQuery__
 *
 * To run a query within a React component, call `useHrisTeamFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisTeamFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisTeamFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisTeamFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<HrisTeamFilterOptionsQuery, HrisTeamFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisTeamFilterOptionsQuery, HrisTeamFilterOptionsQueryVariables>(HrisTeamFilterOptionsDocument, options);
      }
export function useHrisTeamFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisTeamFilterOptionsQuery, HrisTeamFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisTeamFilterOptionsQuery, HrisTeamFilterOptionsQueryVariables>(HrisTeamFilterOptionsDocument, options);
        }
export type HrisTeamFilterOptionsQueryHookResult = ReturnType<typeof useHrisTeamFilterOptionsQuery>;
export type HrisTeamFilterOptionsLazyQueryHookResult = ReturnType<typeof useHrisTeamFilterOptionsLazyQuery>;
export type HrisTeamFilterOptionsQueryResult = Apollo.QueryResult<HrisTeamFilterOptionsQuery, HrisTeamFilterOptionsQueryVariables>;